// extracted by mini-css-extract-plugin
export var container = "_4g-0";
export var containerTopRight = "_4g-1";